import { render, staticRenderFns } from "./PointEstimateList.vue?vue&type=template&id=f073c4c8&"
import script from "./PointEstimateList.vue?vue&type=script&lang=js&"
export * from "./PointEstimateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports